import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { CallNextButton, AttendButton } from '../components';
import { Close as CloseIcon } from '@mui/icons-material';
import { IconButton, Modal } from '@mui/material';
import { useTotemSectorActions } from '../hooks';
import { useTicketFlowModals } from '../context';
import { lastDigits } from '@/utils';

interface CallNextModalProps {
  isOpen?: boolean;
}

export const CallNextModal = ({ isOpen = true }: CallNextModalProps) => {
  const { ticketData, closeModal } = useTicketFlowModals();

  const { onMarkAsWaiting } = useTotemSectorActions();

  const onCloseModal = () => {
    if (!ticketData) return;

    const { trackNumber, sectorId } = ticketData;

    onMarkAsWaiting({
      trackNumber,
      sectorId,
    });

    closeModal();
  };

  return (
    <Modal open={isOpen} disableEscapeKeyDown>
      <div className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2'>
        <div className='flex flex-col p-10 gap-10 w-[520px] h-fit bg-white outline-none rounded-sm'>
          <div className='flex justify-between'>
            <h2 className='text-xl !font-bold'>Estás llamando al número</h2>
            <IconButton onClick={onCloseModal}>
              <CloseIcon />
            </IconButton>
          </div>
          <div className='flex items-center w-fit mx-auto'>
            <span className='text-6xl font-bold animate-pulse'>
              {ticketData ? lastDigits(ticketData?.trackNumber) : 'Sin número'}
            </span>
          </div>
          <div className='flex justify-between'>
            <CallNextButton
              buttonVariant={GlobalButtonVariant.secondaryButton}
            />
            <AttendButton />
          </div>
        </div>
      </div>
    </Modal>
  );
};
